function skAvailabilityCal(elId, options, callback){
	var that = this;
	that.currentDate = null;
	that.toDate = null;
	that.maxDate = null;
	that.skVenueCalendar = {
		opid: null,
		propid: null,
		sellerEntity: null,
		selector: null,
		legendHeadingText: 'Legend',
		showLegend: true,
		showLegendHeading: true,
		calendarHeading: 'Availability',
		roomIds: [],
		resourcesRoot: null,
		legendHeadings: {
			available: 'Available',
			onRequest: 'On Request',
			unavailable: 'Unavailable'
		},
		domainURL: 'book.ibexres.com',
		showCalendarHeading: true,
		showMonthPicker: true,
		showYearPicker: true,
		showScrollers: true,
		excludeLoaders: [],
		isMultiProp: false,
		templateId: null,
		dateClickCallback: null,
		selectedDate: null,
		trackSelectedDate: false,
		calendarsShowing: 4
	};
	that.skVenueCal = {
		loadCal: function(elId, options, callback){
			if(typeof elId === 'undefined' || !elId || !(elId.length)){
				throw new Error('dom element id is required to use skAvailabilityCal');
			} else {
				that.skVenueCalendar.selector = elId;
			}
			if(typeof options === 'undefined'){
				throw new Error('options parameter required to use skAvailabilityCal');
			}
			if(typeof options.opid === 'undefined' || !options.opid){
				throw new Error('operator id required to use skAvailabilityCal');
			} else {
				that.skVenueCalendar.opid = options.opid;
			}
			if(((typeof options.isMultiProp !== 'undefined')&&!(options.isMultiProp)) || typeof options.isMultiProp === 'undefined'){
				if(typeof options.propid === 'undefined' || !options.propid){
					throw new Error('property id required to use skAvailabilityCal');
				} else {
					that.skVenueCalendar.propid = options.propid;
				}
			}
			if(typeof options.sellerEntity !== 'undefined' && options.sellerEntity){
				that.skVenueCalendar.sellerEntity = options.sellerEntity;
			}
			if(typeof options.roomIds !== 'undefined' && options.roomIds){
				that.skVenueCalendar.roomIds = options.roomIds;
			}
			if(typeof options.legendHeadingText !== 'undefined' && options.legendHeadingText){
				that.skVenueCalendar.legendHeadingText = options.legendHeadingText;
			}
			if(typeof options.showLegend !== 'undefined'){
				that.skVenueCalendar.showLegend = options.showLegend;
			}
			if(typeof options.showLegendHeading !== 'undefined'){
				that.skVenueCalendar.showLegendHeading = options.showLegendHeading;
			}
			if(typeof options.calendarHeading !== 'undefined' && options.calendarHeading){
				that.skVenueCalendar.calendarHeading = options.calendarHeading;
			}
			if(typeof options.showCalendarHeading !== 'undefined'){
				that.skVenueCalendar.showCalendarHeading = options.showCalendarHeading;
			}
			if(typeof options.legendHeadings !== 'undefined'){
				if(typeof options.legendHeadings.available !== 'undefined'){
					that.skVenueCalendar.legendHeadings.available = options.legendHeadings.available;
				}
				if(typeof options.legendHeadings.unavailable !== 'undefined'){
					that.skVenueCalendar.legendHeadings.unavailable = options.legendHeadings.unavailable;
				}
				if(typeof options.legendHeadings.onRequest !== 'undefined'){
					that.skVenueCalendar.legendHeadings.onRequest = options.legendHeadings.onRequest;
				}
			}
			if(typeof options.resourcesRoot !== 'undefined'){
				that.skVenueCalendar.resourcesRoot = options.resourcesRoot;
			}
			if(typeof options.showMonthPicker !== 'undefined'){
				that.skVenueCalendar.showMonthPicker = options.showMonthPicker;
			}
			if(typeof options.showYearPicker !== 'undefined'){
				that.skVenueCalendar.showYearPicker = options.showYearPicker;
			}
			if(typeof options.domainURL !== 'undefined'){
				that.skVenueCalendar.domainURL = options.domainURL;
			}
			if(typeof options.showScrollers !== 'undefined'){
				that.skVenueCalendar.showScrollers = options.showScrollers;
			}
			if(typeof options.excludeLoaders !== 'undefined'){
				that.skVenueCalendar.excludeLoaders = options.excludeLoaders;
			}
			if(typeof options.isMultiProp !== 'undefined'){
				that.skVenueCalendar.isMultiProp = options.isMultiProp;
			}
			if(typeof options.templateId !== 'undefined'){
				that.skVenueCalendar.templateId = options.templateId;
			}
			if(typeof options.dateClickCallback !== 'undefined'){
				that.skVenueCalendar.dateClickCallback = options.dateClickCallback;
			}
			if(typeof options.selectedDate !== 'undefined'){
				that.skVenueCalendar.selectedDate = options.selectedDate;
			}
			if(typeof options.trackSelectedDate !== 'undefined'){
				that.skVenueCalendar.trackSelectedDate = options.trackSelectedDate;
			}
			if(typeof options.calendarsShowing !== 'undefined'){
				that.skVenueCalendar.calendarsShowing = options.calendarsShowing;
			}

			that.loadjQuery(function(){
				that.loadScripts(function(){
					that.setup(callback);
				});
			});
			return that;
		}
	};
	that.skVenueDom = {
		hideLegend: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys').addClass('hidden');
		},
		showLegend: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys').removeClass('hidden');
		},
		hideLegendHeading: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys h2.heading').addClass('hidden');
		},
		showLegendHeading: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys h2.heading').removeClass('hidden');
		},
		setLegendHeading: function(heading){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys h2.heading').text(heading);
		},
		hideHeading: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal h2.calendar-heading').addClass('hidden');
		},
		showHeading: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal h2.calendar-heading').removeClass('hidden');
		},
		setHeading: function(heading){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal h2.calendar-heading').text(heading);
		},
		showLoader: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .loader').removeClass('hidden');
		},
		hideLoader: function(){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .loader').addClass('hidden');
		},
		setLegendAvailableHeading: function(heading){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys .key.available').text(heading);
		},
		setLegendUnavailableHeading: function(heading){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys .key.unavailable').text(heading);
		},
		setLegendOnRequestHeading: function(heading){
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .keys .key.onRequest').text(heading);
		},
		showMonthPicker: function(){
			// style the year picker
			var yearPicker = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years');
			yearPicker.addClass('col-xs-6').removeClass('col-xs-12');
			yearPicker.addClass('col-md-4').removeClass('col-md-6');
			yearPicker.addClass('col-lg-3').removeClass('col-lg-6');
			yearPicker.removeClass('col-md-offset-2').removeClass('col-md-offset-3');
			// show the month picker
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months').removeClass('hidden');
		},
		hideMonthPicker: function(){
			// style the year picker
			var yearPicker = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years');
			yearPicker.removeClass('col-xs-6').addClass('col-xs-12');
			yearPicker.removeClass('col-md-4').addClass('col-md-6');
			yearPicker.removeClass('col-lg-3').addClass('col-lg-6');
			yearPicker.removeClass('col-md-offset-2').addClass('col-md-offset-3');
			// hide the month picker
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months').addClass('hidden');
		},
		showYearPicker: function(){
			// style the month picker
			var monthPicker = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months');
			monthPicker.addClass('col-xs-6').removeClass('col-xs-12');
			monthPicker.addClass('col-md-4').removeClass('col-md-6');
			monthPicker.addClass('col-lg-3').removeClass('col-lg-6');
			monthPicker.addClass('col-md-offset-2').removeClass('col-md-offset-3');
			// show the year picker
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years').removeClass('hidden');
		},
		hideYearPicker: function(){
			// style the month picker
			var monthPicker = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months');
			monthPicker.removeClass('col-xs-6').addClass('col-xs-12');
			monthPicker.removeClass('col-md-4').addClass('col-md-6');
			monthPicker.removeClass('col-lg-3').addClass('col-lg-6');
			monthPicker.removeClass('col-md-offset-2').addClass('col-md-offset-3');
			// hide the year picker
			$('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years').addClass('hidden');
		},
		showScrollers: function(){
			var controls = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .controls');
			controls.removeClass('hidden');
		},
		hideScrollers: function(){
			var controls = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .controls');
			controls.addClass('hidden');
		},
		setMonthPickerMonths: function(months){
			var monthSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months');
			monthSelect.find('option').remove().end();
			var yearSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years');
			for(var month in months){
				if(months.hasOwnProperty(month)){
					var opMonth = months[month];
					monthSelect.append('<option value="'+opMonth+'" '+(opMonth === that.currentDate.format('MMMM') ? 'selected' : '')+'>'+opMonth+'</option>');
				}
			}
			monthSelect.on('change', function(){
				that.updateAllCals(monthSelect, yearSelect);
			});
		},
		setYearPickerYears: function(years){
			var monthSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months');
			var yearSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years');
			for(var year in years){
				if(years.hasOwnProperty(year)){
					var opYear = years[year];
					yearSelect.append('<option value="'+opYear+'">'+opYear+'</option>');
				}
			}
			yearSelect.on('change', function(){
				that.updateAllCals(monthSelect, yearSelect);
			});
		},
		setMaxCalendars: function(maxCalendar){

		},
		setupDOM: function(){
			document.getElementById(that.skVenueCalendar.selector).innerHTML = '' +
				'<div id="sk-availability-cal" class="container-fluid">' +
					'<div class="loader">' +
						'<div class="logo-spinner">' +
							'<div class="sqs">' +
								'<div class="sq sq-1"></div>' +
								'<div class="sq sq-2"></div>' +
								'<div class="sq sq-3"></div>' +
								'<div class="sq sq-4"></div>' +
							'</div>' +
						'</div>' +
					'</div>' +
					'<div class="row controls">' +
						'<div class="container-fluid">' +
							'<button class="btn btn-primary col-xs-3 col-sm-1" id="venue-cal-previous"><span class="glyphicon glyphicon-chevron-left"></span></button>' +
							'<div class="col-xs-6 col-sm-10 date-pickers">' +
								'<div class="container-fluid">' +
									'<select class="col-xs-12 col-sm-6 date-picker months"></select>' +
									'<select class="col-xs-12 col-sm-6 date-picker years"></select>' +
								'</div>' +
							'</div>' +
							'<button class="btn btn-primary col-xs-3 col-sm-1" id="venue-cal-next"><span class="glyphicon glyphicon-chevron-right"></span></button>' +
						'</div>' +
					'</div>' +
					'<div class="row">' +
						'<div>' +
							'<h2 class="text-center calendar-heading">Availability</h2>' +
							'<div class="calendar col-xs-12 col-sm-6 col-md-3">' +
								'<div class="venue-calendar" id="venue-calendar-1"></div>' +
							'</div>' +
							'<div class="calendar col-xs-12 col-sm-6 col-md-3 hidden-xs">' +
								'<div class="venue-calendar" id="venue-calendar-2"></div>' +
							'</div>' +
							'<div class="calendar col-xs-12 col-sm-6 col-md-3 hidden-xs hidden-sm">' +
								'<div class="venue-calendar" id="venue-calendar-3"></div>' +
							'</div>' +
							'<div class="calendar col-xs-12 col-sm-6 col-md-3 hidden-xs hidden-sm">' +
								'<div class="venue-calendar" id="venue-calendar-4"></div>' +
							'</div>' +
						'</div>' +
					'</div>' +
					'<div class="row keys">' +
						'<div>' +
							'<h2 class="text-center heading">Legend</h2>' +
							'<div class="key available col-xs-12 col-sm-2 col-sm-offset-3 text-center">Available</div>' +
							'<div class="key onRequest col-xs-12 col-sm-2 text-center">On Request</div>' +
							'<div class="key unavailable col-xs-12 col-sm-2 text-center">Unavailable</div>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'';
		}
	};
	that.scriptsLoaded = {};
	that.loadScript = function(name, url, callback) {
		"use strict";

		if(typeof that.scriptsLoaded[name] !== 'undefined'){
			// Already run, return;
			return false;
		}

		that.scriptsLoaded[name] = true;

		var head = document.getElementsByTagName('head')[0],
			script = document.createElement('script');
		script.type = 'text/javascript';

		if(script.readyState){
			script.onreadystatechange = function(){
				if(script.readyState === 'loaded' || script.readyState === 'complete'){
					script.onreadystatechange = null;
					callback();
				}
			};
		}
		else {
			script.onload = function(){
				callback();
			};
		}

		script.src = url;
		head.appendChild(script);
	};
	that.loadjQuery = function(callback){
		if(typeof window.jQuery === 'undefined' && that.skVenueCalendar.excludeLoaders.indexOf('jquery') === -1){
			that.loadScript('jQuery','dist/assets/js/jquery.min.js', function(){
				callback();
			});
		} else {
			$ = window.jQuery;
			callback();
		}
	};
	that.loadScripts = function(callback){
		var resourcesRoot = '';
		if(that.skVenueCalendar.resourcesRoot){
			resourcesRoot = that.skVenueCalendar.resourcesRoot;
		}
		// load style sheets
		if(that.skVenueCalendar.excludeLoaders.indexOf('bootstrap') === -1){
			$('head').append('<link rel="stylesheet" type="text/css" href="'+resourcesRoot+'dist/assets/css/bootstrap.min.css" />');
		}
		$('head').append('<link rel="stylesheet" type="text/css" href="'+resourcesRoot+'dist/assets/css/skAvailabilityCal.min.css" />');
		$('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">');


		var getCachedScript = function(url, options) {
            options = $.extend( options || {}, {
                dataType: "script",
                cache: true,
                url: url
            });

            // Use $.ajax() since it is more flexible than $.getScript
            // Return the jqXHR object so we can chain callbacks
            return jQuery.ajax( options );
		};

		// load other scripts
		if(that.skVenueCalendar.excludeLoaders.indexOf('moment') === -1){
			getCachedScript(resourcesRoot+'dist/assets/js/underscore-min.js')
				.done(function(){
					getCachedScript(resourcesRoot+'dist/assets/js/moment.min.js')
						.done(function(){
							getCachedScript(resourcesRoot+'dist/assets/js/bootstrap.min.js')
								.done(function(){
									getCachedScript(resourcesRoot+'dist/assets/js/clndr.min.js')
										.done(function(){
											callback();
										});
								});
						});
				});
		} else {
			getCachedScript(resourcesRoot+'dist/assets/js/underscore-min.js')
				.done(function(){
					getCachedScript(resourcesRoot+'dist/assets/js/bootstrap.min.js')
						.done(function(){
							getCachedScript(resourcesRoot+'dist/assets/js/clndr.min.js')
								.done(function(){
									callback();
								});
						});
				});
		}
	};
	that.increaseMonth = function increaseMonth(){
		that.currentDate.date(1);
		that.maxDate = moment().add(2,'years');
		if(!moment(that.currentDate).add(that.skVenueCalendar.calendarsShowing,'months').isBefore(that.maxDate)){
			// max of 2 years is already reached, do not allow to proceed further
			return false;
		}
		var month1 = moment(that.currentDate.add(1,'month'));
		var month2 = moment(that.currentDate.subtract(1,'month').add(2,'month'));
		var month3 = moment(that.currentDate.subtract(2,'month').add(3,'month'));
		var month4 = moment(that.currentDate.subtract(3, 'month').add(4,'months'));
		that.currentDate.subtract(3,'months');
		if(that.currentDate.format('MM-YYYY') === moment().add(2,'years').format('MM-YYYY')){
			that.toDate = moment().add(2,'years');
		} else {
			that.toDate = moment(that.currentDate).add(4, 'months');
		}
		that.cal1.setMonth(month1.month()); that.cal1.setYear(month1.year());
		that.cal2.setMonth(month2.month()); that.cal2.setYear(month2.year());
		that.cal3.setMonth(month3.month()); that.cal3.setYear(month3.year());
		that.cal4.setMonth(month4.month()); that.cal4.setYear(month4.year());
		that.getUpdatedEvents();
	};
	that.decreaseMonth = function(){
		if(moment(that.currentDate).subtract(1,'month').format('MM-YYYY') === moment().format('MM-YYYY')){
			that.currentDate.date(moment().date());
		}
		if((that.currentDate.month() > moment().month()) || (that.currentDate.year() > moment().year())){
			var month1 = moment(that.currentDate.subtract(1,'month'));
			var month2 = moment(that.currentDate.subtract(1,'month').add(2,'month'));
			var month3 = moment(that.currentDate.subtract(2,'month').add(3,'month'));
			var month4 = moment(that.currentDate.subtract(3, 'month').add(4,'months'));
			that.currentDate.subtract(3,'months');
			that.toDate = moment(that.currentDate).add(4,'months');
			that.cal1.setMonth(month1.month()); that.cal1.setYear(month1.year());
			that.cal2.setMonth(month2.month()); that.cal2.setYear(month2.year());
			that.cal3.setMonth(month3.month()); that.cal3.setYear(month3.year());
			that.cal4.setMonth(month4.month()); that.cal4.setYear(month4.year());
			that.getUpdatedEvents();
		}
	};
	that.getUpdatedEvents = function(){
		var url = that.getRequestURL();
		that.skVenueDom.showLoader();
		$.ajax({
			url: url
		}).done(function(data){
			that.setEvents(data);
			// setup the months
			var availMonths = that.getAvailableMonths(that.currentDate.year());
			that.skVenueDom.setMonthPickerMonths(availMonths);
			that.updateSelectedMonth();
			that.updateSelectedYear();
			that.skVenueDom.hideLoader();
		}).error(function(data){
			that.skVenueDom.hideLoader();
		});
	};
	that.getRequestURL = function(){
		// check if it is multi prop
		if(!that.skVenueCalendar.isMultiProp){
			if((typeof that.skVenueCalendar !== 'undefined') && (typeof that.skVenueCalendar.opid !== 'undefined') && (typeof that.skVenueCalendar.propid !== 'undefined') && that.skVenueCalendar.opid && that.skVenueCalendar.propid){
				var url = "https://";
				if(window.location.protocol != 'https:'){
					var url = 'http://';
				}
				url +=that.skVenueCalendar.domainURL+"/open-api/get-property-sell-status/";
				url += that.skVenueCalendar.opid + '/';
				url += that.skVenueCalendar.propid + '/';
				url += that.currentDate.format('YYYY-MM-DD') + '/';
				url += that.toDate.format('YYYY-MM-DD') + '/';
				if(typeof that.skVenueCalendar.sellerEntity !== 'undefined' && that.skVenueCalendar.sellerEntity){
					url += that.skVenueCalendar.sellerEntity;
				}
				if(that.skVenueCalendar.roomIds.length > 0){
					url += '?';
					for(var i = 0, iLen = that.skVenueCalendar.roomIds.length; i < iLen; i++){
						url += 'roomIds[]=' + that.skVenueCalendar.roomIds[i];
						if((i + 1) < iLen){
							url += '&';
						}
					}
				}
				return url;
			} else {
				throw new Error('Please check the integration guide, you are missing the setup details for skAvailabilityCal to run');
			}
		} else {
			if((typeof that.skVenueCalendar !== 'undefined') && (typeof that.skVenueCalendar.opid !== 'undefined') && that.skVenueCalendar.opid){
				var url = "https://"+that.skVenueCalendar.domainURL+"/open-api/get-properties-sell-status/";
				url += that.skVenueCalendar.opid + '/';
				url += that.currentDate.format('YYYY-MM-DD') + '/';
				url += that.toDate.format('YYYY-MM-DD') + '/';
				if(typeof that.skVenueCalendar.sellerEntity !== 'undefined' && that.skVenueCalendar.sellerEntity){
					url += that.skVenueCalendar.sellerEntity;
				}
				if(that.skVenueCalendar.roomIds.length > 0){
					url += '?';
					for(var i = 0, iLen = that.skVenueCalendar.roomIds.length; i < iLen; i++){
						url += 'roomIds[]=' + that.skVenueCalendar.roomIds[i];
						if((i + 1) < iLen){
							url += '&';
						}
					}
				}
				if(that.skVenueCalendar.templateId){
					if(url.indexOf('?' + 'roomIds[]' + '=') != -1){
						url += '&templateId=';
						url += that.skVenueCalendar.templateId;
					} else {
						url += '?templateId=';
						url += that.skVenueCalendar.templateId;
					}
				}
				return url;
			} else {
				throw new Error('Please check the integration guide, you are missing the setup details for skAvailabilityCal to run');
			}
		}
	};
	that.setEvents = function(events){
		var formattedEvents = that.getFormattedEvents(events);
		that.cal1.setEvents(formattedEvents);
		that.cal2.setEvents(formattedEvents);
		that.cal3.setEvents(formattedEvents);
		that.cal4.setEvents(formattedEvents);
	};
	that.getEventType = function(typeID){
		var type = "";
		switch(typeID){
			case 0:
				type = "unavailable";
				break;
			case 1:
				type = "onRequest";
				break;
			case 2:
				type = "available";
				break;
			default:
				type = "unavailable";
				console.warn('please check if there is an updated for skVenueCal, an event type has been detected that isn\'t supported in this version');
				break;
		}
		return type;
	};
	that.getFormattedEvents = function(events){
		var listedEvents = [];
		for(var event in events){
			if(events.hasOwnProperty){
				var theEvent = {
					date: moment(event,'YYYY-MM-DD'),
					type: that.getEventType(events[event])
				};
				listedEvents.push(theEvent);
			}
		}
		return listedEvents;
	};
	that.setup = function(callback){
		// setup the dom
		that.skVenueDom.setupDOM();
		that.currentDate = moment();
		that.toDate = moment(that.currentDate).add(4,'months');
		that.getUpdatedEvents();
		var clndrTemplate =
	        "<div class='clndr-controls'>" +
	            "<div class='clndr-control-button'>" +
	                "<span class='clndr-previous-button'>previous</span>" +
	            "</div>" +
	            "<div class='month'><%= month %> <%= year %></div>" +
	            "<div class='clndr-control-button rightalign'>" +
	                "<span class='clndr-next-button'>next</span>" +
	            "</div>" +
	        "</div>" +
	        "<table class='clndr-table' border='0' cellspacing='0' cellpadding='0'>" +
	            "<thead>" +
	                "<tr class='header-days'>" +
	                "<% for(var i = 0; i < daysOfTheWeek.length; i++) { %>" +
	                    "<td class='header-day'><%= daysOfTheWeek[i] %></td>" +
	                "<% } %>" +
	                "</tr>" +
	            "</thead>" +
	            "<tbody>" +
	            "<% for(var i = 0; i < numberOfRows; i++){ %>" +
	                "<tr>" +
	                "<% for(var j = 0; j < 7; j++){ %>" +
	                "<% var d = j + i * 7; %>" +
	                    "<td class='<%= days[d].classes %>'>" +
	                        "<div class='day-contents <%= (typeof days[d].events !== \'undefined\' && days[d].events.length > 0) ? days[d].events[0].type : \'\' %>'><%= days[d].day %>" +
	                        	"<% _.each(days[d].events, function(event){ %>" +
		                        	"<div class=\"event <%=event.type %>\"></div> " +
	                        	"<% }) %>" +
	                        "</div>" +
	                    "</td>" +
	                "<% } %>" +
	                "</tr>" +
	            "<% } %>" +
	            "</tbody>" +
	        "</table>";
		// setup the onrequest
		that.cal1 = $('#' + that.skVenueCalendar.selector + ' #venue-calendar-1').clndr({
			template: clndrTemplate,
			classes: {
				past: 'date-past',
				inactive: 'unavailable',
				event: 'on-request'
			},
			events: [],
			adjacentDaysChangeMonth: false,
			showAdjacentMonths: false,
			constraints: {
				startDate: moment().format('YYYY-MM-DD'),
				endDate: moment().add(5, 'Year').format('YYYY-MM-DD')
			},
			selectedDate: (that.skVenueCalendar.selectedDate) ? that.skVenueCalendar.selectedDate : null,
			trackSelectedDate: that.skVenueCalendar.trackSelectedDate,
			clickEvents: {
				click: (typeof that.skVenueCalendar.dateClickCallback === 'function') ? that.skVenueCalendar.dateClickCallback : function(event){}
			}
		});
		that.cal2 = $('#' + that.skVenueCalendar.selector + ' #venue-calendar-2').clndr({
			template: clndrTemplate,
			classes: {
				past: 'date-past',
				inactive: 'unavailable',
				event: 'on-request'
			},
			events: [],
			adjacentDaysChangeMonth: false,
			showAdjacentMonths: false,
			constraints: {
				startDate: moment().add(1,'month').format('YYYY-MM-DD'),
				endDate: moment().add(5, 'Year').format('YYYY-MM-DD')
			},
			selectedDate: (that.skVenueCalendar.selectedDate) ? that.skVenueCalendar.selectedDate : null,
			trackSelectedDate: that.skVenueCalendar.trackSelectedDate,
			clickEvents: {
				click: (typeof that.skVenueCalendar.dateClickCallback === 'function') ? that.skVenueCalendar.dateClickCallback : function(event){}
			}
		});
		that.cal3 = $('#' + that.skVenueCalendar.selector + ' #venue-calendar-3').clndr({
			template: clndrTemplate,
			classes: {
				past: 'date-past',
				inactive: 'unavailable',
				event: 'on-request'
			},
			events: [],
			adjacentDaysChangeMonth: false,
			showAdjacentMonths: false,
			constraints: {
				startDate: moment().add(2,'months').format('YYYY-MM-DD'),
				endDate: moment().add(5, 'Year').format('YYYY-MM-DD')
			},
			selectedDate: (that.skVenueCalendar.selectedDate) ? that.skVenueCalendar.selectedDate : null,
			trackSelectedDate: that.skVenueCalendar.trackSelectedDate,
			clickEvents: {
				click: (typeof that.skVenueCalendar.dateClickCallback === 'function') ? that.skVenueCalendar.dateClickCallback : function(event){}
			}
		});
		that.cal4 = $('#' + that.skVenueCalendar.selector + ' #venue-calendar-4').clndr({
			template: clndrTemplate,
			classes: {
				past: 'date-past',
				inactive: 'unavailable',
				event: 'on-request'
			},
			events: [],
			adjacentDaysChangeMonth: false,
			showAdjacentMonths: false,
			constraints: {
				startDate: moment().add(3,'months').format('YYYY-MM-DD'),
				endDate: moment().add(5, 'Year').format('YYYY-MM-DD')
			},
			selectedDate: (that.skVenueCalendar.selectedDate) ? that.skVenueCalendar.selectedDate : null,
			trackSelectedDate: that.skVenueCalendar.trackSelectedDate,
			clickEvents: {
				click: (typeof that.skVenueCalendar.dateClickCallback === 'function') ? that.skVenueCalendar.dateClickCallback : function(event){}
			}
		});

		// setup preferences
		if(that.skVenueCalendar.showLegend){
			that.skVenueDom.showLegend();
		} else {
			that.skVenueDom.hideLegend();
		}
		if(that.skVenueCalendar.showLegendHeading){
			that.skVenueDom.showLegendHeading();
		} else {
			that.skVenueDom.hideLegendHeading();
		}
		if(that.skVenueCalendar.showCalendarHeading){
			that.skVenueDom.showHeading();
		} else {
			that.skVenueDom.hideHeading();
		}
		if(that.skVenueCalendar.showScrollers){
			that.skVenueDom.showScrollers();
		} else {
			that.skVenueDom.hideScrollers();
		}
		if(that.skVenueCalendar.showYearPicker){
			that.skVenueDom.showYearPicker();
		} else {
			that.skVenueDom.hideYearPicker();
		}
		if(that.skVenueCalendar.showMonthPicker){
			that.skVenueDom.showMonthPicker();
		} else {
			that.skVenueDom.hideMonthPicker();
		}
		that.skVenueDom.setHeading(that.skVenueCalendar.calendarHeading);
		that.skVenueDom.setLegendHeading(that.skVenueCalendar.legendHeadingText);

		// setup the legend headings
		that.skVenueDom.setLegendAvailableHeading(that.skVenueCalendar.legendHeadings.available);
		that.skVenueDom.setLegendUnavailableHeading(that.skVenueCalendar.legendHeadings.unavailable);
		that.skVenueDom.setLegendOnRequestHeading(that.skVenueCalendar.legendHeadings.onRequest);

		// setup the next button and previous button event handlers
		$('#' + that.skVenueCalendar.selector + ' button#venue-cal-previous').on('click', function(event){
			that.decreaseMonth();
			event.preventDefault();
		});
		$('#' + that.skVenueCalendar.selector + ' button#venue-cal-next').on('click', function(event){
			that.increaseMonth();
			event.preventDefault();
		});

		// setup the month and year pickers
		var availMonths = that.getAvailableMonths(moment().year());
		var availYears = that.getAvailableYears();
		that.skVenueDom.setMonthPickerMonths(availMonths);
		that.skVenueDom.setYearPickerYears(availYears);
		if(callback){
			callback();
		}
	};
	that.cal1 = null;
	that.cal2 = null;
	that.cal3 = null;
	that.cal4 = null;
	that.getAvailableMonths = function (year){
		var currentDate = moment();
		// check year is in the future
		if(moment().year(year).year() < moment().year()){
			throw new Error('The year given to getAvailableMonths must be a year in the future. Previous year was given');
		}
		if(moment().year(year).year() > moment().add(2,'years').year()){
			throw new Error('The year given to getAvailableMonths must be no more than 2 years from the current year');
		}
		var availableMonths = [];
		if(year === moment().year()){
			availableMonths.push(currentDate.format('MMMM'));
			// return from this month onwards
			while(currentDate.add(1, 'Month').year() === moment().year()){
				availableMonths.push(currentDate.format('MMMM'));
			}
		} else if (year === moment().add(1,'year').year()){
			var startDate = moment().month(0);
			availableMonths.push(startDate.format('MMMM'));
			for(var month = 1, months = 12; month < months; month++){
				availableMonths.push(startDate.add(1, 'month').format('MMMM'));
			}
		} else if (year === moment().add(2,'year').year()){
			var startDate = moment().month(0);
			availableMonths.push(startDate.format('MMMM'));
			for(var month = 1, months = moment().month(); month <= months; month++){
				availableMonths.push(startDate.add(1, 'month').format('MMMM'));
			}
		} else {
			availableMonths = [];
		}
		return availableMonths;
	};
	that.getAvailableYears = function(){
		var currentDate = moment(), availableYears = [];
		availableYears.push(currentDate.year());
		while(currentDate.add(1,'year').year() <= moment().add(2, 'years').year()){
			availableYears.push(currentDate.year());
		}
		return availableYears;
	};
	that.setStartDate = function(month, year){
		var changeToDate = moment().month(month).year(year);
		if((changeToDate.month() > moment().month()) && (changeToDate.year() > moment().year())){
			that.currentDate.month(month).year(year).date(1);
			that.toDate = moment(that.currentDate).add(4,'months');
		} else if ((changeToDate.month() <= moment().month()) && (changeToDate.year() > moment().year())){
			that.currentDate.month(month).year(year).date(1);
			that.toDate = moment(that.currentDate).add(4,'months');
		} else if ((changeToDate.month() > moment().month()) && (changeToDate.year() === moment().year())) {
			that.currentDate.month(month).year(year).date(1);
			that.toDate = moment(that.currentDate).add(4,'months');
		} else if((changeToDate.month() === moment().month()) && (changeToDate.year() === moment().add(2,'years').year())){
			that.currentDate.month(month).year(year).date(moment().date());
			that.toDate = that.currentDate;
		} else {
			that.currentDate = moment();
			that.toDate = moment(that.currentDate).add(4,'months');
		}

		if(!changeToDate.isBefore(moment().subtract(4,'months').add(2,'years'))){
			that.toDate = moment().add(2,'years');
		}
	};
	that.updateAllCals = function(monthSelect, yearSelect){
		that.setStartDate(monthSelect.val(), yearSelect.val());
		that.skVenueDom.setMonthPickerMonths(that.getAvailableMonths(that.currentDate.year()));
		var month1 = moment(that.currentDate);
		var month2 = moment(that.currentDate.subtract(1,'month').add(2,'month'));
		var month3 = moment(that.currentDate.subtract(2,'month').add(3,'month'));
		var month4 = moment(that.currentDate.subtract(3, 'month').add(4,'months'));
		that.currentDate.subtract(3,'months');
		that.toDate = moment(that.currentDate).add(4,'months');
		that.cal1.setMonth(month1.month()); that.cal1.setYear(month1.year());
		that.cal2.setMonth(month2.month()); that.cal2.setYear(month2.year());
		that.cal3.setMonth(month3.month()); that.cal3.setYear(month3.year());
		that.cal4.setMonth(month4.month()); that.cal4.setYear(month4.year());
		that.getUpdatedEvents();
	};
	that.updateSelectedMonth = function (){
		var monthSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.months');
		monthSelect.val(that.currentDate.format('MMMM'));
	};
	that.updateSelectedYear = function(){
		var yearSelect = $('#' + that.skVenueCalendar.selector + ' #sk-availability-cal .date-pickers select.years');
		yearSelect.val(that.currentDate.year());
	};

	// auto constructor run
	that.skVenueCal.loadCal(elId, options, callback);
	return that;
}
